import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import './styles/index.scss'
import ListPagination from '@/components/ListPagination.vue'

Vue.use(ElementUI)
Vue.component('ListPagination', ListPagination)
Vue.config.productionTip = false
new Vue({ router, store, render: (h) => h(App) }).$mount('#app')
